<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <div class="title mb-4">
          {{ $t("fcm_notifications") }}
          <span> ({{ restaurant?.name || $t("restaurant_not_selected") }}) </span>
        </div>
        <v-row>
          <v-col cols="12" lg="4">
            <autocomplete
              :items="projects"
              v-model="notification.project"
              :label="$t('project')"
              item-text="name"
              item-id="code"
              return-object
            >
            </autocomplete>
            <br />
            <v-radio-group v-model="row" row v-if="isAdmin">
              <v-radio
                :label="$t('restaurant')"
                value="restaurant"
                v-show="isAdmin"
              ></v-radio>
              <v-radio :label="$t('companies')" value="company"></v-radio>
            </v-radio-group>

            <text-field :label="$t('title')" v-model="title"></text-field>
            <text-area :label="$t('message')" v-model="message"></text-area>

            <primary-button
              class="mt-4"
              @click="send"
              :loading="loading"
              :disabled="loading || selected.length === 0 || !message"
              :dark="!loading && !!selected.length && message"
              color="primary"
              height="48px"
              block
            >
              <v-icon class="mr-2">mdi-send</v-icon>
              {{ $t("send") }}
            </primary-button>
          </v-col>
          <v-col cols="12" lg="8">
            <v-row no-gutters align="center" class="mb-4">
              <dropdown
                :label="$t('view')"
                :items="showItems"
                v-model="selectedLayout"
                hide-details
                outlined
                dense
              ></dropdown>
            </v-row>
            <v-row v-if="row === 'company'" align="end">
              <v-col cols="12" md="4">
                <dropdown
                  :items="notificationTypes"
                  v-model="selectedNotificationType"
                  :label="'Tip notifikacije'"
                  item-text="text"
                  item-value="value"
                  outlined
                  dense
                  hide-details
                ></dropdown>
              </v-col>
              <v-col cols="12" md="4">
                <date-picker
                  v-model="date"
                  single-date
                  :label="getDateLabel()"
                  outlined
                  dense
                ></date-picker>
              </v-col>
              <!-- v-col cols="12" md="4" class="d-flex align-center">
                <v-checkbox
                  @click="selectAllFirmUsers()"
                  v-model="firm_users"
                  :label="$t('all_users')"
                  hide-details
                  class="mt-0"
                >
                </v-checkbox>
              </v-col -->
            </v-row>
            <v-row>
              <v-col cols="12" v-if="row === 'company'">
                <v-row align="end">
                  <v-col>
                    <autocomplete
                      :items="companies"
                      v-model="selectedCompanies"
                      select-all
                      multiple
                      :label="$t('company')"
                      item-text="name"
                      item-id="id"
                      return-object
                    ></autocomplete>
                  </v-col>
                  <v-col cols="auto">
                    <primary-button @click="getUsers" height="40px">
                      {{ $t("search") }}
                    </primary-button>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <p
                  v-if="count_orders"
                  style="display: flex; justify-content: space-between"
                >
                  <span class="font-weight-bold">{{
                    $t("ordered_qty").toUpperCase() + ": " + count_orders
                  }}</span>
                  <span class="font-weight-bold">{{
                    ($t("no") + " " + $t("ordered_qty")).toUpperCase() +
                    ": " +
                    users.length
                  }}</span>
                </p>
                <v-data-table
                  v-model="selected"
                  :headers="headers"
                  :items="users"
                  :items-per-page="5"
                  class="ordera-box-shadow striped-table"
                  item-key="id"
                  show-select
                  :loading="loading"
                  :loading-text="$t('loading_data')"
                >
                  <template v-slot:item.num="{ item, index }">
                    {{ index + 1 }}
                  </template>
                  <template v-slot:item.user.messageStatus="{ item }">
                    {{ item.messageStatus || $t("pending") }}
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment/moment";
import companyService from "@/services/company";
import orderService from "@/services/order";
import notificationService from "@/services/notification";
import hasSnackbar from "@/mixins/hasSnackbar";
import warehouseFiltersMixin from "@/mixins/warehouse/warehouseFiltersMixin";


export default {
  mixins: [hasSnackbar, warehouseFiltersMixin],
  data() {
    return {
      selected: [],
      date: "",
      date1: "",
      selectedNotificationType: "",
      notificationTypes: [
        { text: this.$t('all_users'), value: "" },
        { text: "Nije naručio na vrijeme", value: "filter-not-ordered-on-time" },
        { text: "Nije preuzeo narudžbu", value: "filter-not-picked-up" },
        { text: "Preuzeo rezervni obrok", value: "filter-used-resrved" },
        { text: "Naručio obrok", value: "filter-ordered" }
      ],
      menu: false,
      menu1: false,
      notification: {
        project: { code: "ordera-e6eb8", name: "Ordera" },
      },
      projects: [
        { code: "ordera-e6eb8", name: "Ordera" },
        { code: "order-notification-8f5f2", name: "Restorani" },
      ],
      headers: [],
      users: [],
      originalUsers: [],
      loading: false,
      info: {
        state: false,
        list: [],
      },
      title: "",
      message: "",
      companies: [],
      selectedCompanies: [],
      row: "company",
      firm_users: false,
      no_order_on_time_users: false,
      orders_not_taken: false,
      count_orders: null,
      selectedLayout: { text: this.$t("meals_in_meals"), value: "daily" },
    };
  },
  created() {
    this.headers = [
      { text: this.$t("r_b"), value: "num" },
      {
        text: this.$t("name"),
        align: "start",
        sortable: false,
        value: "name",
      },
      { text: this.$t("lastname"), value: "lastname" },
      { text: this.$t("email"), value: "email" },
      { text: this.$t("type"), value: "type" },
      { text: this.$t("state"), value: "messageStatus" },
    ];
    this.getUsers();
    this.loadCompanies();
  },
  methods: {
    getDateLabel() {
      if (this.selectedNotificationType === 'not-ordered-on-time') {
        return this.$t('not_ordered_on_time') || 'Nije naručio na vrijeme';
      } else if (this.selectedNotificationType === 'not-picked-up') {
        return this.$t('not_picked_up') || 'Nije preuzeo narudžbu';
      }
      return this.$t('date') || 'Datum';
    },
    toogleAllCompanies() {
      if (this.selectedCompanies.length > 0) {
        this.selectedCompanies = [];
        this.getUsers();
      } else if (this.selectedCompanies.length == 0) {
        this.selectedCompanies = [];
        // for(let company in this.report_food_original) {
        //   this.searchFoodCompany.push(company)
        // }
        this.companies.filter((com) => {
          this.selectedCompanies.push(com);
        });
        this.getUsers();
      }
      this.$forceUpdate();
    },
    selectAllFirmUsers() {
      if (this.firm_users) {
        this.users = this.originalUsers;
        this.date = "";
        this.date1 = "";
        this.count_orders = null;
      }
    },
    loadNotTakenOrders() {
      if (this.selectedCompanies.length) {
        let firme = [];
        let korisnikId = [];
        this.selectedCompanies.filter((item) => {
          firme.push(item.id);
        });
        this.users.filter((user) => {
          korisnikId.push(user.id);
        });
        orderService
          .filterNotTakenOrders({
            companies: firme,
            date: this.date,
            users: korisnikId,
          })
          .then(({ data }) => {
            this.users = data.no_order;
            this.firm_users = false;
          })
          .catch(() => {
            this.showErrorSnackbar(this.$t("error_loading_not_taken_orders"));
          });
      }
    },
    loadOrdersTime() {
      if (this.selectedCompanies.length) {
        let firme = [];
        let korisnikId = [];
        this.selectedCompanies.filter((item) => {
          firme.push(item.id);
        });
        this.users.filter((user) => {
          korisnikId.push(user.id);
        });
        orderService
          .filterNotOnTimeOrders({
            companies: firme,
            date: this.date,
            users: korisnikId,
          })
          .then(({ data }) => {
            this.users = data.no_order;
            this.count_orders = data.order;
            this.firm_users = false;
          })
          .catch(() => {
            this.showErrorSnackbar(this.$t("error_loading_orders_time"));
          });
      }
    },
    loadCompanies() {
      this.companies = [];
      companyService
        .getCompaniesWithRestaurants()
        .then((res) => {
          this.companies = (res.data || []).reduce((companies, company) => {
            companies.push(company);
            if ((company.children || []).length) {
              companies = companies.concat(company.children);
            }
            return companies;
          }, []);
        })
        .catch(() => {
          this.showErrorSnackbar(this.$t("error_loading_companies"));
        });
      this.$forceUpdate();
    },
    getUsers() {
      this.loading = true;

      const params = {
        project: this.notification.project.code,
        row: this.row,
        type: this.selectedLayout.value === 'daily' ? 'meal' : 'group',
      };

      if (this.row === "restaurant") {
        params.restaurant_ids = this.restaurant.id;
      } else {
        params.company_ids = this.selectedCompanies.map((i) => i.id).join(",");
      }

      params.date = this.date;
      if(this.selectedNotificationType) params[this.selectedNotificationType] = true;

      notificationService
        .getUsers(params)
        .then((res) => {
          this.users = res.data;
          this.originalUsers = res.data;
        })
        .finally(() => {
          this.loading = false;
        })
        .catch(() => {
          this.showErrorSnackbar(this.$t("error_loading_users"));
        });
    },
    send() {
      this.loading = true;
      notificationService
        .sendFcm({
          project: this.notification.project.code,
          user_ids: this.selected.map((user) => user.id),
          title: this.title,
          body: this.message,
        })
        .then((res) => {
          this.info.list = res.data;
          this.users = this.users.map((user) => {
            let newUserSuccess = this.info.list.find(
              (i) => i.user_id === user.id && i.response.name
            );
            let newUserFailed = this.info.list.find(
              (i) => i.user_id === user.id && i.response.error
            );

            if (!user.messageStatus) {
              if (newUserSuccess) {
                user.messageStatus = this.$t("ok");
              } else {
                if (newUserFailed) {
                  user.messageStatus = this.$t("failed");
                }
              }

              if (!newUserSuccess && !newUserFailed) {
                user.messageStatus = this.$t("not_found_token");
              }
            }

            return user;
          });
          this.showSuccessSnackbar(this.$t("notifications_sent"));
        })
        .catch(() => {
          this.showErrorSnackbar(this.$t("error_sending_notifications"));
        })
        .finally(() => {
          this.loading = false;
          this.info.state = true;
        });
    },
  },
  computed: {
    isAdmin() {
      return this.$store.state.user?.user?.type === "admin";
    },
    dateRangeText() {
      if (this.date.length == 1 || this.date[0] == this.date[1]) {
        return moment(this.date[0]).format("DD.MM.YYYY");
      }
      return (
        moment(this.date[0]).format("DD.MM.YYYY") +
        " - " +
        moment(this.date[1]).format("DD.MM.YYYY")
      );
    },
    restaurant() {
      return this.$store.state.restaurant;
    },
  },
  watch: {
    restaurant() {
      this.getUsers();
      this.loadCompanies();
    },
    "notification.project"() {
      this.getUsers();
    },
    selectedCompanies() {
      this.getUsers();
    },
    row() {
      this.getUsers();
    },
    date() {
      if(this.selectedNotificationType === 'not-ordered-on-time') {
        //this.loadOrdersTime();
      } else if(this.selectedNotificationType === 'not-picked-up') {
        //this.loadNotTakenOrders();
      }

      this.getUsers();
    },
    selectedNotificationType() {
      if(this.selectedNotificationType === 'not-ordered-on-time') {
        //this.loadOrdersTime();
      } else if(this.selectedNotificationType === 'not-picked-up') {
        //this.loadNotTakenOrders();
      }

      this.getUsers();
    },
    selectedLayout() {
      this.getUsers();
    },
  },
};
</script>
